import { render, staticRenderFns } from "./BDInput.vue?vue&type=template&id=22dcb482&scoped=true&"
import script from "./BDInput.vue?vue&type=script&lang=js&"
export * from "./BDInput.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22dcb482",
  null
  
)

export default component.exports